import React, { useEffect, useState } from 'react';
import { Container, Row, Stack } from 'react-bootstrap';
import { asve } from '../orve';
import {
  getAssessmentContentPercentile,
  getAssessmentContentCutoffs,
  getAssessmentText,
  getCandidateExtraversionText,
} from '../report-util';
import { useAuth } from '../../../../providers/auth-provider';
import { REPORT_TYPE } from '../../../../utils/constants';

function CoachingPersonalityPage2({ candidate, reportType = REPORT_TYPE.development }) {
  const { isSelect } = useAuth();
  const [assessmentText, setAssessmentText] = useState({});

  useEffect(() => {
    if (candidate) {
      setAssessmentText(asve(candidate));
    }
  }, [candidate]);

  return (
    <Container className="bg-white mt-2 mb-3 candidate-profile-assessments">
      {candidate && (
        <>
          <Container className="candidate-profile-assessment-content">
            <Row className="justify-content-left w-50">
              <h3 className="pt-4 pb-1">PERSONALITY</h3>
            </Row>
            <Row className="w-100 mx-auto justify-content-center pt-4">
              <Stack direction="horizontal" className="subscore-chart">
                <div className="w-25">
                  {getAssessmentContentCutoffs(
                    getCandidateExtraversionText(isSelect(), true),
                    candidate.personality.scores.extraversion.overall,
                    undefined,
                    reportType
                  )}
                </div>
                <div className="w-75">{getAssessmentText(assessmentText.extraversion)}</div>
              </Stack>
              <Row className="w-100 mx-auto justify-content-center ms-5">
                <Stack direction="horizontal" className="subscore-chart">
                  <div className="w-25">
                    {getAssessmentContentCutoffs(
                      'Social Self-Esteem',
                      candidate.personality.scores.extraversion.socialSelfEsteem,
                      undefined,
                      reportType
                    )}
                  </div>
                  <div className="w-75">{getAssessmentText(assessmentText.socialSelfEsteem)}</div>
                </Stack>
                <Stack direction="horizontal" className="subscore-chart">
                  <div className="w-25">
                    {getAssessmentContentCutoffs(
                      'Social Boldness',
                      candidate.personality.scores.extraversion.socialBoldness,
                      undefined,
                      reportType
                    )}
                  </div>
                  <div className="w-75">{getAssessmentText(assessmentText.socialBoldness)}</div>
                </Stack>
                <Stack direction="horizontal" className="subscore-chart">
                  <div className="w-25">
                    {getAssessmentContentCutoffs(
                      'Outgoing',
                      candidate.personality.scores.extraversion.socialbility,
                      undefined,
                      reportType
                    )}
                  </div>
                  <div className="w-75">{getAssessmentText(assessmentText.socialbility)}</div>
                </Stack>
                <Stack direction="horizontal" className="subscore-chart">
                  <div className="w-25">
                    {getAssessmentContentCutoffs(
                      'Liveliness',
                      candidate.personality.scores.extraversion.liveliness,
                      undefined,
                      reportType
                    )}
                  </div>
                  <div className="w-75">{getAssessmentText(assessmentText.liveliness)}</div>
                </Stack>
              </Row>
              <Stack direction="horizontal" className="subscore-chart">
                <div className="w-25">
                  {getAssessmentContentCutoffs(
                    'Conscientiousness',
                    candidate.personality.scores.conscientiousness.overall,
                    undefined,
                    reportType
                  )}
                </div>
                <div className="w-75">{getAssessmentText(assessmentText.conscientiousness)}</div>
              </Stack>
              <Row className="w-100 mx-auto justify-content-center ms-5">
                <Stack direction="horizontal" className="subscore-chart">
                  <div className="w-25">
                    {getAssessmentContentCutoffs(
                      'Organization',
                      candidate.personality.scores.conscientiousness.organization,
                      undefined,
                      reportType
                    )}
                  </div>
                  <div className="w-75">{getAssessmentText(assessmentText.organization)}</div>
                </Stack>
                <Stack direction="horizontal" className="subscore-chart">
                  <div className="w-25">
                    {getAssessmentContentCutoffs(
                      'Diligence',
                      candidate.personality.scores.conscientiousness.diligence,
                      undefined,
                      reportType
                    )}
                  </div>
                  <div className="w-75">{getAssessmentText(assessmentText.diligence)}</div>
                </Stack>
                <Stack direction="horizontal" className="subscore-chart">
                  <div className="w-25">
                    {getAssessmentContentCutoffs(
                      'Perfectionism',
                      candidate.personality.scores.conscientiousness.perfectionism,
                      undefined,
                      reportType
                    )}
                  </div>
                  <div className="w-75">{getAssessmentText(assessmentText.perfectionism)}</div>
                </Stack>
                <Stack direction="horizontal" className="subscore-chart">
                  <div className="w-25">
                    {getAssessmentContentCutoffs(
                      'Prudence',
                      candidate.personality.scores.conscientiousness.prudence,
                      undefined,
                      reportType
                    )}
                  </div>
                  <div className="w-75">{getAssessmentText(assessmentText.prudence)}</div>
                </Stack>
              </Row>
            </Row>
            <Row className="mt-2 justify-content-left w-50">
              <h3 className="pt-4 pb-1">ACUMEN</h3>
              <Stack direction="horizontal" gap={4}>
                {getAssessmentContentPercentile('Overall Acumen', candidate.percentiles.acumen, reportType)}
              </Stack>
            </Row>
            <Row className="w-100 pb-4">{getAssessmentText(assessmentText.acumen)}</Row>
          </Container>
        </>
      )}
    </Container>
  );
}

export default CoachingPersonalityPage2;
